import React from "react";
import update from "immutability-helper";
import { ParentDetails } from "./ParentDetails.jsx";
export class ChildrenEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            kids: props.accountChildren.length > 0 ? props.accountChildren.map( (child, index) => Object.assign(child, { id: ""+index }) ) : [{}],
            loaded: false
        }
    }

    upd(spec) {
        this.setState(update(this.state, spec), () => {
            this.props.onCountChange(
                this.state.kids.length
            );
        });
    }

    componentDidMount() {
        this.upd({ loaded: { $set: true } });//Trip state check.
    }

    addKid() {
        this.upd({ kids: { $push: [{}] } })
    }
    removeKid(idx) {
        if (
            this.state.kids.length > 1
        ) {
            this.upd({ kids: { $splice: [[idx, 1]] } })
        }
    }

    render() {
        const canRemove = (
            this.state.kids.length > 1
        );
        let guardian = this.props.guardian;
        return <div className="js-ballpit">
            
            {this.state.kids.map((kid, idx) => <div key={idx}><ChildrenEntry
                idx={idx}
                value={kid}
                onChange={kid => this.upd({ kids: { [idx]: { $set: kid } } })}
                onRemove={canRemove ? () => this.removeKid(idx) : null}
            />
            {idx == this.state.kids.length - 1 && <button type="button" id="js-add-kid" onClick={() => this.addKid()}>Add Child</button>}
            </div>)}
            {this.state.kids.length == 0 && <button type="button" id="js-add-kid" onClick={() => this.addKid()}>Add Child</button>}

            <ParentDetails guardianName={guardian.name} mobile={guardian.mobile} phone={guardian.phone} email={guardian.email} />
        </div>
    }
}


export class ChildrenEntry extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            showRemoveModal: false, 
            showMedical: (props.value.med ||"").length > 0, 
            showDiet: (props.value.diet ||"").length > 0,
            showSend: (props.value.send ||"").length > 0
        };
    }
    
    render() {
        let props = this.props;
        let removeMessage = props.removeMessage || "Are you sure you want to remove this child from the booking?";
        let bind = key => ({ value: props.value[key] || "", onChange: ev => props.onChange(Object.assign({}, props.value, { [key]: ev.target.value })) })
        let bindDirect = key => ({ value: props.value[key] || "", onChange: ev => props.onChange(Object.assign({}, props.value, { [key]: ev })) })
        let isEmpty = (props.value.first || "").trim().length == 0 && (props.value.last || "").trim().length == 0
        let medicalFieldRows = 1;
        let dietaryFieldRows = 1;
        let sendFieldRows = 1;
        if (props.value.med) {
            const lines = props.value.med.split("\n").reduce((t, l) => {
                return t + 1 + Math.floor(l.length / 40)
            }, 0)

            medicalFieldRows = Math.min(10, Math.max(1, lines));
        }
        if (props.value.diet) {
            const lines = props.value.diet.split("\n").reduce((t, l) => {
                return t + 1 + Math.floor(l.length / 40)
            }, 0)

            dietaryFieldRows = Math.min(10, Math.max(1, lines));
        }
        if (props.value.send) {
            const lines = props.value.send.split("\n").reduce((t, l) => {
                return t + 1 + Math.floor(l.length / 40)
            }, 0)

            sendFieldRows = Math.min(10, Math.max(1, lines));
        }

        let heading = <h3>Child&apos;s Details</h3>;
        if(props.value.id !== undefined) {
            heading = <h3>{props.value.first} {props.value.last}</h3>;
        }

        let removeModal = null;
        if(this.state.showRemoveModal) {
            removeModal = <div className="overlay">
                <div className="overlay-container">
                    <p>{removeMessage}</p>
                    <button type="button" onClick={()=>{
                        this.setState({ showRemoveModal: false });
                        props.onRemove();
                    }}>Remove</button>
                    <a href="#" onClick={ev=>{
                        this.setState({ showRemoveModal: false });
                        ev.preventDefault();
                    }}>Cancel</a>
                </div>
            </div>
        }

        return <fieldset className="child-details">
            {heading}
            <input type="hidden" name="child-id[]" value={props.value.id || ""} />
            <div className="grouped-inputs-1">
                <div className="input-group">
                    <label>First name *</label>
                    <input type="text" name="child-name-first[]" required  {...bind("first")} />
                </div>
                <div className="input-group">
                    <label>Last name *</label>
                    <input type="text" name="child-name-last[]" required {...bind("last")} />
                </div>
            </div>
            <div className="input-group">
                <label>Date of birth *</label>
                <BirthdaySelector {...bindDirect("dob")} />
            </div>

            <div className="input-group">
                <label>School year at the time of attendance</label>
                <select className="school-year" name="child-year[]" required {...bind("school-year")} >
                    <option value="">Please select a school year</option>
                    <option value="Nursery">Nursery</option>
                    <option value="Reception">Reception</option>
                    <option value="Year 1">Year 1</option>
                    <option value="Year 2">Year 2</option>
                    <option value="Year 3">Year 3</option>
                    <option value="Year 4">Year 4</option>
                    <option value="Year 5">Year 5</option>
                    <option value="Year 6">Year 6</option>
                    <option value="Year 7">Year 7</option>
                    <option value="Year 8">Year 8</option>
                </select>
            </div>

            
            <div className="grouped-inputs-full">
                <div className="input-group">
                    <label>Any medical conditions to be aware of? *</label>
                    <div className="button-set" id="show-medical">
                    
                        <input type="radio" id={`show-medical-${props.idx}-y`} checked={this.state.showMedical} onClick={() => this.setState({ showMedical: true })} /> 
                        <label htmlFor={`show-medical-${props.idx}-y`}><span>Yes</span></label>
                        <input type="radio" id={`show-medical-${props.idx}-n`} checked={!this.state.showMedical} onClick={() => this.setState({ showMedical: false })} />
                        <label htmlFor={`show-medical-${props.idx}-n`}><span>No</span></label>
                    </div>
                    {
                        this.state.showMedical
                            ?
                            <textarea name="child-medical[]" rows={medicalFieldRows} {...bind("med")} required></textarea>
                            :
                            <input type="hidden" name="child-medical[]" value="" />
                    }
                    <div style={{ clear: "both" }}></div>
                </div>
            </div>
            <div className="grouped-inputs-full">
                <div className="input-group">
                    <label>Any dietary requirements to be aware of? *</label>
                    <div className="button-set" id="show-diet">
                    
                        <input type="radio" id={`show-diet-${props.idx}-y`} checked={this.state.showDiet} onClick={() => this.setState({ showDiet: true })} /> 
                        <label htmlFor={`show-diet-${props.idx}-y`}><span>Yes</span></label>
                        <input type="radio" id={`show-diet-${props.idx}-n`} checked={!this.state.showDiet} onClick={() => this.setState({ showDiet: false })} />
                        <label htmlFor={`show-diet-${props.idx}-n`}><span>No</span></label>
                    </div>
                    {
                        this.state.showDiet
                            ?
                            <textarea name="child-dietary[]" rows={dietaryFieldRows} {...bind("diet")} required></textarea>
                            :
                            <input type="hidden" name="child-dietary[]" value="" />
                    }
                    <div style={{ clear: "both" }}></div>
                </div>
            </div>

            <div className="grouped-inputs-full">
                <div className="input-group">
                    <label>Any SEND (Special educational needs and disability) requirements to be aware of? *</label>
                    <div className="button-set" id="show-send">
                    
                        <input type="radio" id={`show-send-${props.idx}-y`} checked={this.state.showSend} onClick={() => this.setState({ showSend: true })} /> 
                        <label htmlFor={`show-send-${props.idx}-y`}><span>Yes</span></label>
                        <input type="radio" id={`show-send-${props.idx}-n`} checked={!this.state.showSend} onClick={() => this.setState({ showSend: false })} />
                        <label htmlFor={`show-send-${props.idx}-n`}><span>No</span></label>
                    </div>
                    {
                        this.state.showSend
                            ?
                            <textarea name="child-send[]" rows={sendFieldRows} {...bind("send")} required></textarea>
                            :
                            <input type="hidden" name="child-send[]" value="" />
                    }
                    <div style={{ clear: "both" }}></div>
                </div>
            </div>

            

            {props.onRemove != undefined ?
                <button type="button" onClick={()=>{
                    if(isEmpty) {
                        props.onRemove();
                    } else {
                        this.setState({ showRemoveModal: true });
                    }                    

                }}>Remove Child</button>
                :
                null
            }

            {removeModal}
            
        </fieldset>
    }
}

export function BirthdaySelector({ value, onChange }) {
    let startYear = (new Date()).getFullYear() - 3; // 4 -13 Yr olds, but birthdays and dates and weird, lets err on side of caution and go +/- 1yr.
    let endYear = (new Date()).getFullYear() - 14;

    let [year = startYear, month = "01", day = "01"] = value.split("-");

    let dayCount = 31;
    console.log("idx", ["09", "04", "06", "11"].indexOf(month), month, typeof month);
    if ( ["09", "04", "06", "11"].indexOf(month) != -1){
        dayCount = 30;
    }
    if(month == 2){
        let isLeapYear =  ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
        if( isLeapYear ){
            dayCount = 29;
        }else{
            dayCount = 28;
        }
    }
    if(day > dayCount){
        day = Math.min(day, dayCount);
        setTimeout(()=>{
            onChange(`${year}-${month}-${day}`)
        }, 1)
    }

    
    return <div className="birthday-selector">
        <input type="hidden" name="child-dob[]" value={value || "2004-01-01"} />
        <select className="birthday-selector__day" required value={day} onChange={ev => {
            onChange(`${year}-${month}-${ev.target.value}`)
        }}>
            {(()=>{
                let days = [];
                for(let i = 1; i <= dayCount; i++){
                    days.push(<option key={i}>{ i < 10 ? "0" + i : i }</option>)
                }

                return days;
            })()}
        </select>
        <select className="birthday-selector__month" required value={month} onChange={ev => onChange(`${year}-${ev.target.value}-${day}`)} >
            <option value="01">January</option>
            <option value="02">Febuary</option>
            <option value="03">March</option>
            <option value="04">April</option>
            <option value="05">May</option>
            <option value="06">June</option>
            <option value="07">July</option>
            <option value="08">August</option>
            <option value="09">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
        </select>
        <select  className="birthday-selector__year" required value={year} onChange={ev => onChange(`${ev.target.value}-${month}-${day}`)}>
            {(() => {
                let a = [];
                for (let yr = endYear; yr <= startYear; yr++) {
                    a.push(<option key={yr}>{yr}</option>);
                }
                return a;
            })()}
        </select>
    </div>

}


// WEBPACK FOOTER //
// ./flexi/ChildrenEditor.jsx